import {
  LayoutDashboard, FileText, ClipboardList, ScrollText, Receipt, AlertTriangle,
  RefreshCw, Users, ShieldCheck, UserCog, Building2, BarChart3, Settings, Briefcase,
  Inbox, Info, Phone, HelpCircle, Flag, ClipboardCheck, Inbox as InboxIcon, Package,
} from "lucide-react";

export const customerMenu = [
  { label: "Dashboard", to: "/dashboard", icon: LayoutDashboard },
  { label: "Post Requirement", to: "/post-requirement", icon: FileText },
  { label: "My Requirements", to: "/requirements", icon: ClipboardList },
  { label: "Contracts", to: "/contracts", icon: ScrollText },
  { label: "Invoices", to: "/invoices", icon: Receipt },
  { label: "Incidents", to: "/incidents", icon: AlertTriangle },
  { label: "Replacements", to: "/replacements", icon: RefreshCw },
];

export const agencyMenu = [
  { label: "Dashboard", to: "/agency", icon: LayoutDashboard },
  { label: "My Leads", to: "/agency/my-leads", icon: InboxIcon },
  { label: "Leads", to: "/agency/leads", icon: ClipboardList },
  { label: "My Quotations", to: "/agency/quotes", icon: FileText },
  { label: "Guards", to: "/agency/guards", icon: Users },
  { label: "Contracts", to: "/agency/contracts", icon: ScrollText },
  { label: "Invoices", to: "/agency/invoices", icon: Receipt },
  { label: "Agency Profile", to: "/agency/profile", icon: Briefcase },
];

export const adminMenu = [
  { label: "Overview", to: "/admin", icon: LayoutDashboard },
  { label: "Lead Management", to: "/admin/lead-management", icon: ClipboardCheck, leadManager: true },
  { label: "Leads", to: "/admin/leads", icon: ClipboardList },
  { label: "Verification", to: "/admin/verification", icon: ShieldCheck },
  { label: "Agencies", to: "/admin/agencies", icon: Building2 },
  { label: "Packages", to: "/admin/packages", icon: Package },
  { label: "Users", to: "/admin/users", icon: UserCog },
  { label: "Enquiries", to: "/admin/enquiries", icon: Inbox, leadManager: true },
  { label: "Reports", to: "/admin/reports", icon: Flag },
  { label: "About Page", to: "/admin/content/about", icon: Info },
  { label: "Contact Info", to: "/admin/content/contact", icon: Phone },
  { label: "FAQs", to: "/admin/faqs", icon: HelpCircle },
  { label: "Analytics", to: "/admin/analytics", icon: BarChart3 },
  { label: "Settings", to: "/admin/settings", icon: Settings },
];
